import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { dashboardService } from "../../services/admin";

// Dashboard Hooks
export const useDashboardStats = () => {
	const { user } = useAuth();
	const isAdmin = user?.role === "admin" || user?.role === "superAdmin";

	return useQuery({
		queryKey: ["dashboard-stats"],
		queryFn: dashboardService.getStats,
		enabled: isAdmin, // Only fetch if user is admin
		refetchInterval: 30000, // Refetch every 30 seconds
		retry: 2,
		staleTime: 1000 * 60, // 1 minute
	});
};
